import {
    CLEAR_CARDS_SERCH,
    CLEAR_CARDS_SEARCH_SUCCESS,
    UPDATE_CARDS_SELECTS,
    UPDATE_CARDS_TEXT,
    UPDATE_CARDS_SELECTS_SUCCESS,
    UPDATE_CARDS_SELECTS_FAIL,
    UPDATE_CARDS_TEXT_SUCCESS,
    UPDATE_CARDS_TEXT_FAIL,
    CLEAR_PRODUCTS_SERCH,
    CLEAR_PRODUCTS_SEARCH_SUCCESS,
    UPDATE_PRODUCTS_SELECTS,
    UPDATE_PRODUCTS_TEXT,
    UPDATE_PRODUCTS_SELECTS_SUCCESS,
    UPDATE_PRODUCTS_SELECTS_FAIL,
    UPDATE_PRODUCTS_TEXT_SUCCESS,
    UPDATE_PRODUCTS_TEXT_FAIL
} from '../actions/search';

const state = { 
    cardsFilters: { sections:[], contexts:[], text: ''},
    productsFilters: { sections:[], contexts:[], text: ''},
};

const getters = {
    cardsFilters: (state) => {
        return state.cardsFilters;
    },
    cardsSections: (state) => {
        return state.cardsFilters.sections;
    },
    cardsContexts: (state) => {
        return state.cardsFilters.contexts;
    },
    cardsText: (state) => {
        return state.cardsFilters.text;
    },
    productsFilters: (state) => {
        return state.productsFilters;
    },
    productsSections: (state) => {
        return state.productsFilters.sections;
    },
    productsContexts: (state) => {
        return state.productsFilters.contexts;
    },
    productsText: (state) => {
        return state.productsFilters.text;
    }    
}

const actions = {
    [CLEAR_CARDS_SERCH] : ({commit}) => {
        return new Promise((resolve) => { 
            var filters = {sections:[], contexts:[], text: ''};
            commit(CLEAR_CARDS_SEARCH_SUCCESS, filters);
            resolve(state.cardsFilters);
        });
    },
    [UPDATE_CARDS_SELECTS]: ({commit}, data) => {
        return new Promise((resolve, reject) => {
            if(data.sections!=null && data.contexts!=null){       
                commit(UPDATE_CARDS_SELECTS_SUCCESS, {contexts: data.contexts, sections: data.sections});
                resolve(state.cardsFilters);
            }else{
                reject(UPDATE_CARDS_SELECTS_FAIL);
            }
        });
    },
    [UPDATE_CARDS_TEXT]: ({commit}, text) => {
        return new Promise((resolve,reject)=>{
            if(text!=null){
                commit(UPDATE_CARDS_TEXT_SUCCESS, text);
                resolve(state.cardsFilters.text);
            }else{
                reject(UPDATE_CARDS_TEXT_FAIL);
            }
        });
    },
    [CLEAR_PRODUCTS_SERCH] : ({commit}) => {
        return new Promise((resolve) => { 
            var filters = {sections:[], contexts:[], text: ''};
            commit(CLEAR_PRODUCTS_SEARCH_SUCCESS, filters);
            resolve(state.productsFilters);
        });
    },
    [UPDATE_PRODUCTS_SELECTS]: ({commit}, data) => {
        return new Promise((resolve, reject) => {
            if(data.sections!=null && data.contexts!=null){       
                commit(UPDATE_PRODUCTS_SELECTS_SUCCESS, {contexts: data.contexts, sections: data.sections});
                resolve(state.productsFilters);
            }else{
                reject(UPDATE_PRODUCTS_SELECTS_FAIL);
            }
        });
    },
    [UPDATE_PRODUCTS_TEXT]: ({commit}, text) => {
        return new Promise((resolve,reject)=>{
            if(text!=null){
                commit(UPDATE_PRODUCTS_TEXT_SUCCESS, text);
                resolve(state.productsFilters.text);
            }else{
                reject(UPDATE_PRODUCTS_TEXT_FAIL);
            }
        });
    }
}

const mutations = {
    [CLEAR_CARDS_SEARCH_SUCCESS]: (state,filters) => {
        state.cardsFilters = filters;        
    },
    [UPDATE_CARDS_SELECTS_SUCCESS]: (state, data) => {
        state.cardsFilters.sections = data.sections;
        state.cardsFilters.contexts = data.contexts;
    },
    [UPDATE_CARDS_SELECTS_FAIL]: (state) =>{
        state.cardsFilters.sections = [];
        state.cardsFilters.contexts = [];
    },
    [UPDATE_CARDS_TEXT_SUCCESS]: (state, text) => {
        state.cardsFilters.text = text;
    },
    [UPDATE_CARDS_TEXT_FAIL]: (state) =>{
        state.cardsFilters.text = "";
    },
    [CLEAR_PRODUCTS_SEARCH_SUCCESS]: (state,filters) => {
        state.productsFilters = filters;        
    },
    [UPDATE_PRODUCTS_SELECTS_SUCCESS]: (state, data) => {
        state.productsFilters.sections = data.sections;
        state.productsFilters.contexts = data.contexts;
    },
    [UPDATE_PRODUCTS_SELECTS_FAIL]: (state) =>{
        state.productsFilters.sections = [];
        state.productsFilters.contexts = [];
    },
    [UPDATE_PRODUCTS_TEXT_SUCCESS]: (state, text) => {
        state.productsFilters.text = text;
    },
    [UPDATE_PRODUCTS_TEXT_FAIL]: (state) =>{
        state.productsFilters.text = "";
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};
